import { useEffect, memo } from 'react';

import Slide from '@mui/material/Slide';

import { Portal } from '@vk-hr-tek/ui/Portal';
import { Box } from '@vk-hr-tek/ui/Box';
import { Icon } from '@vk-hr-tek/ui/Icon';
import {
  removeNotificationManually,
  selectNotifications,
  getNotifications,
} from '@vk-hr-tek/core/notifications';

import { useSelector, useDispatch } from '../../app/hooks';

import { NotificationContent } from './NotificationContent';
import { useStyles } from './Notifications.styles';

interface NotificationsProps {
  show?: boolean;
}

export const Notifications = memo(({ show = true }: NotificationsProps) => {
  const dispatch = useDispatch();
  const { classes } = useStyles();

  const notifications = useSelector(selectNotifications);

  const handleNotificationRemoval = (id: number) => () =>
    dispatch(removeNotificationManually(id));

  useEffect(() => {
    dispatch(getNotifications());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!show) {
    return null;
  }

  return (
    <Portal>
      <div className={classes.notifications}>
        <div className={classes.stack}>
          {!!notifications &&
            !!notifications.length &&
            notifications.map(
              ({ id, message, type, title, action, subtitle }, index) => {
                return (
                  <Slide
                    direction="left"
                    // eslint-disable-next-line no-magic-numbers
                    timeout={500 + index * 200}
                    in
                    key={id}
                    mountOnEnter
                    unmountOnExit
                  >
                    <Box mb="8">
                      <NotificationContent
                        text={message}
                        title={title}
                        subtitle={subtitle}
                        action={action}
                        handleClose={handleNotificationRemoval(id)}
                        icon={
                          type === 'error' ? (
                            <Icon
                              name="dismiss_substract"
                              size="24"
                              color="accent.text.error"
                            />
                          ) : (
                            <Icon
                              name="check_circle_on"
                              size="24"
                              color="original.brand.primary"
                            />
                          )
                        }
                      />
                    </Box>
                  </Slide>
                );
              },
            )}
        </div>
      </div>
    </Portal>
  );
});
